export default __webpack_public_path__ + "static/blob5-22b55e28f2069f4337978956b30c3885.svg";